import { render, staticRenderFns } from "./CategoryDelete.vue?vue&type=template&id=d465cb98&scoped=true"
import script from "./CategoryDelete.vue?vue&type=script&lang=js"
export * from "./CategoryDelete.vue?vue&type=script&lang=js"
import style0 from "./CategoryDelete.vue?vue&type=style&index=0&id=d465cb98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d465cb98",
  null
  
)

export default component.exports